import { Button, styled } from "@mui/material";
import { useNavigate } from "react-router";

import ErrorOutlineIcon from "@/assets/icons/error-outline.svg?react";

import styles from "./styles.module.css";

const StyledButton = styled(Button)(({ theme }) => ({
  padding: "13px 16px",
  fontSize: "17px",
  fontWeight: "600",
  lineHeight: "22px",
  color: theme.palette.common.white,
  textTransform: "none",
  borderRadius: "8px",
  [theme.breakpoints.up("md")]: {
    maxWidth: "328px",
    width: "100%",
  },
}));

const ErrorFallback = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <ErrorOutlineIcon width={56} height={56} color="#FF9500" />
        <p>
          Не удалось выполнить запрос. <br /> Попробуйте перезагрузить страницу
        </p>
      </div>
      <StyledButton variant="contained" onClick={() => navigate(0)}>
        Перезагрузить
      </StyledButton>
    </div>
  );
};

export default ErrorFallback;
